// Mock data for Frandy Landing Page

export const productFeatures = [
  {
    id: 1,
    title: "100% Plant-Based",
    description: "Made with natural ingredients, sweetened by monk fruit. Vegan-friendly and delicious.",
    icon: "Leaf"
  },
  {
    id: 2,
    title: "Berry Blast Flavour",
    description: "Delicious mix of strawberries and blueberries in every bite.",
    icon: "Cherry"
  },
  {
    id: 3,
    title: "Complete Nutrition",
    description: "15 essential vitamins including A, C, D, E, B7(Biotin), and minerals.",
    icon: "Sparkles"
  },
  {
    id: 4,
    title: "No Artificial Colors",
    description: "Colored naturally with fruit and vegetable extracts. Pure and safe.",
    icon: "ShieldCheck"
  },
  {
    id: 5,
    title: "Easy Daily Dose",
    description: "Just 2 gummies a day for complete multivitamin support.",
    icon: "CalendarCheck"
  },
  {
    id: 6,
    title: "Lab Tested",
    description: "Third-party tested for purity, potency, and safety standards.",
    icon: "FlaskConical"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Free Pre-Order",
    description: "Reserve your bottle with just your email. No payment required."
  },
  {
    step: 2,
    title: "We Notify You",
    description: "Get exclusive early access when Frandy launches."
  },
  {
    step: 3,
    title: "Start Your Journey",
    description: "Receive your Berry Blast gummies and boost your wellness."
  }
];

export const vitamins = [
  { name: "Vitamin A", amount: "400 mcg", benefit: "Vision & Immune" },
  { name: "Vitamin C", amount: "43 mg", benefit: "Antioxidant Power" },
  { name: "Vitamin D3", amount: "120 IU", benefit: "Bone & Mood" },
  { name: "Vitamin E", amount: "5 mg", benefit: "Skin Health" },
  { name: "Vitamin B7", amount: "40 mcg", benefit: "Hair & Skin" },
  { name: "Zinc", amount: "4 mg", benefit: "Immune Support" }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Wellness Enthusiast",
    content: "Finally, a multivitamin that doesn't taste like medicine! The berry flavour is incredible, and I actually look forward to taking them daily.",
    rating: 5
  },
  {
    id: 2,
    name: "James Rodriguez",
    role: "Fitness Coach",
    content: "I recommend Frandy to all my clients. Plant-based, delicious, and effective. The perfect addition to any wellness routine.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Chen",
    role: "Busy Professional",
    content: "As someone who's always on the go, these gummies are a game-changer. Easy to remember, tasty, and I can feel the difference in my energy levels.",
    rating: 5
  }
];

export const faqs = [
  {
    question: "What makes Frandy different from other multivitamins?",
    answer: "Frandy is 100% plant-based, naturally sweetened with monk fruit, and colored with real fruit extracts. No artificial ingredients, just pure nutrition with an amazing berry blast flavour."
  },
  {
    question: "How many gummies should I take per day?",
    answer: "We recommend taking 2 gummies daily, preferably with a meal. Each serving provides your complete daily multivitamin needs."
  },
  {
    question: "Is the pre-order really free?",
    answer: "Yes! Pre-ordering is completely free. We only need your email to reserve your spot. You'll be notified when Frandy launches and can decide to purchase then."
  },
  {
    question: "Are Frandy gummies suitable for vegans?",
    answer: "Absolutely! Frandy is 100% plant-based and vegan-friendly. We use pectin instead of gelatin, making it perfect for everyone."
  },
  {
    question: "When will Frandy be available?",
    answer: "We're launching very soon! Pre-order now to get exclusive early access and be the first to experience Berry Blast multivitamin gummies."
  },
  {
    question: "Are there any allergens I should know about?",
    answer: "Frandy is free from common allergens including gluten, dairy, soy, and nuts. However, always check the full ingredient list if you have specific concerns."
  }
];

export const mockChatResponses = [
  "Thanks for your interest in Frandy! Our Berry Blast gummies are packed with 15 essential vitamins. What would you like to know?",
  "Great question! Frandy contains Vitamins A, C, D3, E, B-Complex (B1, B2, B3, B5, B6, B12), B7(Biotin), and minerals like Zinc. All in delicious berry flavour!",
  "Pre-ordering is super easy and completely free! Just enter your email above, and you'll be the first to know when we launch.",
  "Absolutely! Frandy is 100% plant-based and vegan-friendly. We use pectin instead of gelatin."
];
